export default "__VITE_ASSET__8060126d__"